import React, { Component } from 'react';
import BackupcarStore from 'stores/BackupcarStore';
// import { Button, Modal, Form, FormGroup, Col, ControlLabel, FormControl, InputGroup, OverlayTrigger, Popover } from 'react-bootstrap'
import BackupCarReservedModal from './BackupCarReservedModal'
import Moment from 'moment';
// import FontAwesome from 'react-fontawesome'
// import DatePicker from 'component/element/DatePicker'
// import CkTimePicker from 'component/element/CkTimePicker'
// import SearchCarButton from 'component/element/SearchCarButton'
// import { SliderPicker } from 'react-color';
import { Box } from 'reactjs-admin-lte'
// import Select from 'react-select';
import './carplan.css'
import ConfirmPopup from 'component/element/ConfirmPopup';
// import { Checkbox } from 'react-icheck';
var wait_load = 0
const NotificationSystem = require('react-notification-system');
class CarPlan extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      loading:false,
      showEdit:false,
      id:null,
      ref_no:null,
      isSave:true,
      doc:this.getEmptyDoc(),
      validDoc:this.getEmptyValidDoc(),
      seq:-1,
      myear:Moment().format('YYYY'),
      mmonth:Moment().format('MM'),
      lock_load:false,
      load_first:true,
      bg_select:'#0288d1',
      showConfirm:false,
      msgConfirmEdit:'',
      pre_doc:this.getEmptyPreDoc(),
      db_new_click:false,
      is_return:false
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
    this.timelineConfig()
    this.loadData((data)=>{
      this.initTimeline(data)
    })
  }

  getEmptyDoc() {
    return {return_status:"0",return_date:null,return_time:null,ref_no:"",remark:"",car_registration_no:"",start_date:"",end_date:"",work_no:"",background:"#0288d1"}
  }

  getEmptyValidDoc() {
    return {return_date_time:null,ref_no:null,car_registration_no:null,start_date:null,end_date:null}
  }

  getEmptyPreDoc() {
    return {return_status:"0",return_date:null,return_time:null,ref_no:"",remark:"",car_registration_no:"",start_date:"",end_date:"",work_no:"",background:"#0288d1",bg_select:"",id:"",seq:"",o_start_date:"",o_end_date:""}
  }

  loadData(completeFunc=undefined) {
    let {myear,mmonth} = this.state
    let allDay = Moment(myear+'-'+mmonth,'YYYY-MM').daysInMonth()
    let start_date = '01/'+mmonth+'/'+myear
    let end_date = allDay+'/'+mmonth+'/'+myear
    BackupcarStore.loadReservationItems(start_date,end_date,(result) => {
      this.setState({data:result.data},()=>{
        if (completeFunc!==undefined)
          completeFunc(result.data)
      })
    });
  }

  onConfirmDel(completeFunc=undefined) {
    let {data,seq} = this.state
    let backupcar_reserved_id = data[seq].backupcar_reserved_id
    this.setState({loading:true},()=>{
      BackupcarStore.delReservationItems(backupcar_reserved_id,(result)=>{
        if (result.status==='OK') {
          this._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message:'ลบรายการสำเร็จ',
            level:'info',
            position:'tc'        
          });
          this.setState({bg_select:'#0288d1',load_first:true,data:data,showEdit:false,is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),id:null,ref_no:null,seq:-1},()=>{
            if (completeFunc!==undefined)
              completeFunc(result.status)
            this.loadData((d)=>{
              this.initTimeline(d,1)
              setTimeout(()=>{
                this.setState({loading:false})
              },1000)
            })
          })
        }
      },()=>{
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'เกิดข้อผิดพลาดในการลบรายการ กรุณาลองใหม่อีกครั้ง',
          level:'error',
          position:'tc'        
        });
        if (completeFunc!==undefined)
          completeFunc('ERROR')
        this.setState({loading:false,bg_select:'#0288d1',showEdit:false,is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),id:null,ref_no:null,seq:-1})
      })
    })
  }

  onConfirmEditHide(is_load=0) {
    this.setState({loading:true},()=>{
      let {data,pre_doc} = this.state
      data[pre_doc.seq].start_date = JSON.parse(JSON.stringify(pre_doc.o_start_date))
      data[pre_doc.seq].end_date = JSON.parse(JSON.stringify(pre_doc.o_end_date))
      this.setState({data:data},()=>{
        this.setState({showConfirm:false,msgConfirmEdit:'',pre_doc:this.getEmptyPreDoc()},()=>{
          if (is_load) {
            this.loadData((d)=>{
              this.initTimeline(d,1)
              setTimeout(()=>{
                this.setState({loading:false})
              },1000)
            }) 
          } else {
            this.initTimeline(data)
            setTimeout(()=>{
              this.setState({loading:false})
            },1000)
          }   
        })
      })
    })  
  }

  onConfirmEditSave() {
    let {doc,pre_doc,bg_select} = this.state
    doc.ref_no = JSON.parse(JSON.stringify(pre_doc.ref_no))
    doc.car_registration_no = JSON.parse(JSON.stringify(pre_doc.car_registration_no))
    doc.start_date = JSON.parse(JSON.stringify(pre_doc.start_date))
    doc.end_date = JSON.parse(JSON.stringify(pre_doc.end_date))
    doc.work_no = JSON.parse(JSON.stringify(pre_doc.work_no))
    doc.remark = JSON.parse(JSON.stringify(pre_doc.remark))
    doc.background = JSON.parse(JSON.stringify(pre_doc.background))
    doc.return_date = JSON.parse(JSON.stringify(pre_doc.return_date))
    doc.return_time = JSON.parse(JSON.stringify(pre_doc.return_time))
    bg_select = JSON.parse(JSON.stringify(pre_doc.bg_select))
    this.setState({bg_select:bg_select,id:JSON.parse(JSON.stringify(pre_doc.id)),doc:doc,ref_no:JSON.parse(JSON.stringify(pre_doc.ref_no)),seq:JSON.parse(JSON.stringify(pre_doc.seq))},()=>{
      this.onEditSave(0,()=>{
        this.onConfirmEditHide(1)
      })
    })  
  }

  onJustEditHide() {
    this.setState({showEdit:false})
  }

  onBeforeEditSave(obj,completeFunc=undefined) {
    this.setState({
      validDoc:obj.validDoc,
      doc:obj.doc,
      seq:obj.seq,
      is_return:obj.is_return
    },()=>{
      this.onEditSave(1,()=>{
        if (completeFunc!==undefined)
          completeFunc()
      })
    })
  }

  onEditSave(is_load=1,completeFunc=undefined) {
    let {validDoc,doc,data,seq,is_return} = this.state
    this.setState({loading:true,validDoc:this.getEmptyValidDoc(),isSave:false},()=>{
      let start_date_check = new Date(doc.start_date)
      let end_date_check = new Date(doc.end_date)
      if (doc.ref_no==='') {
        validDoc.ref_no = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (doc.car_registration_no==='') {
        validDoc.car_registration_no = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (doc.start_date==='') {
        validDoc.start_date = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (doc.end_date==='') {
        validDoc.end_date = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (is_return&&(!doc.return_date||!doc.return_time)) {
        validDoc.return_date_time = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        return false
      } else if (start_date_check>end_date_check) {
        validDoc.end_date = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false},()=>{
          this.refs.backupCarReservedModal.getWrappedInstance().onValid(validDoc)
        })
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ไม่สามารถบันทึกรายการได้ เนื่องจากวันคืนรถต้องมากกว่าวันยืมรถ',
          level:'error',
          position:'tc'        
        });
        return false
      }
      let postData = {}
      if (seq===-1) {
        data.push({
          background: doc.background,
          car_registration_no: doc.car_registration_no,
          end_date: doc.end_date,
          ref_no: doc.ref_no,
          remark: doc.remark,
          return_status: "0",
          start_date: doc.start_date,
          work_no: doc.work_no,
          backupcar_reserved_id: null,
          return_date: doc.return_date,
          return_time: doc.return_time,
          return_status: doc.return_status
        })
        postData = data[data.length-1]
      } else {
        data[seq].car_registration_no = doc.car_registration_no
        data[seq].start_date = doc.start_date
        data[seq].end_date = doc.end_date
        data[seq].work_no = doc.work_no
        data[seq].background = doc.background
        data[seq].ref_no = doc.ref_no
        data[seq].return_date = doc.return_date
        data[seq].return_time = doc.return_time
        data[seq].return_status = doc.return_status
        data[seq].remark = doc.remark
        postData = data[seq]
      }
      this.setState({data:data},()=>{
        BackupcarStore.saveReservationItems(postData,(result)=>{
          if (result.status==='OK') {
            if (seq===-1) {
              data[data.length-1].backupcar_reserved_id = result.id
            }
            this._notificationSystem.addNotification({
              title:'แจ้งเตือน',
              message:'บันทึกรายการสำเร็จ',
              level:'info',
              position:'tc'        
            });
            this.setState({bg_select:'#0288d1',load_first:true,data:data,showEdit:false,is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),id:null,ref_no:null,seq:-1},()=>{
              if (is_load) {
                this.loadData((d)=>{
                  this.initTimeline(d,1)
                  setTimeout(()=>{
                    this.setState({loading:false},()=>{
                      if (completeFunc!==undefined)
                        completeFunc(result.status)
                    })
                  },1000)
                })
              } else {
                this.setState({loading:false},()=>{
                  if (completeFunc!==undefined)
                    completeFunc()
                })
              }  
            })  
          } else {
            this._notificationSystem.addNotification({
              title:'แจ้งเตือน',
              message:'เกิดข้อผิดพลาดในการบันทึกรายการ กรุณาลองใหม่อีกครั้ง',
              level:'error',
              position:'tc'        
            });
            this.setState({loading:false,bg_select:'#0288d1',showEdit:false,is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),id:null,ref_no:null,seq:-1},()=>{
              if (completeFunc!==undefined)
                completeFunc(result.status)
            })
          }
        })
      })    
    })  
  }

  onEditHide() {
    let {db_new_click} = this.state
    this.setState({bg_select:'#0288d1',showEdit:false,is_return:false,id:null,ref_no:null,seq:-1,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc()},()=>{
      if (db_new_click) { 
        this.setState({loading:true},()=>{
          this.initTimeline(this.state.data)
          setTimeout(()=>{
            this.setState({loading:false,db_new_click:false})
          },1000)
        })  
      }    
    })
  }

  timelineConfig() {
    let {doc,myear,mmonth,bg_select,pre_doc,msgConfirmEdit,is_return} = this.state
    let that = this
    var view_name = "timeline";

    const scheduler = window.scheduler;
    scheduler.locale.labels.timeline_tab = "Month";
    scheduler.locale.labels.section_custom = "Section";
    scheduler.config.details_on_create = false;
    scheduler.config.details_on_dblclick = false;
    scheduler.config.header = [
      // "day",
      // "week",
      // "month",
      // "timeline",
      "date",
      "prev",
      "today",
      "next"
    ]  
    scheduler.locale.labels.dhx_cal_today_button = "วันนี้"
    //Ref https://docs.dhtmlx.com/scheduler/localization.html
    scheduler.locale.date = {
          month_full:["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", 
              "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
          month_short:["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", 
              "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
          day_full:["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", 
              "วันศุกร์", "วันเสาร์"],
          day_short:["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."]
      }

    // timeline config
    // scheduler.attachEvent("onBeforeEventCreated", function (e){
    //   //any custom logic here
    //   return false;
    // });

    // var dragged_event;
    var o_ref_no;
    var o_start;
    var o_end;
    var o_offsetX;
    scheduler.attachEvent("onBeforeDrag", function (id, mode, e){
      // use it to get the object of the dragged event
      // dragged_event = scheduler.getEvent(id);
      if (id) {
        o_ref_no = scheduler.getEvent(id).section_id;
        o_start = scheduler.getEvent(id).start_date_text;
        o_end = scheduler.getEvent(id).end_date_text;
        o_offsetX = e.offsetX
        return true;
      } else 
        return false;  
    });
    
    scheduler.attachEvent("onDragEnd", function(id, mode, e){
      function convertDate(str) {
        var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        return [day,mnth,date.getFullYear()].join("/")
      }
      if (scheduler.getEvent(id).seq!==undefined) {
        // var event_obj = dragged_event;
        var n_offsetX = e.offsetX;
        var new_ref_no = scheduler.getEvent(id).section_id
        var new_start = convertDate(scheduler.getEvent(id).start_date)
        var new_end = convertDate(scheduler.getEvent(id).end_date)
        
        if (mode==='move'&&new_ref_no===o_ref_no&&new_start===o_start&&new_end===o_end) {
          return false
        } else if (mode==='resize') {
          if (o_offsetX===n_offsetX)
            return false
          if (o_start===new_start) {
            var new_end_str = Moment(scheduler.getEvent(id).end_date).subtract(1, "days");
            new_end = convertDate(new_end_str)
          } 
          if (new_ref_no===o_ref_no&&new_start===o_start&&new_end===o_end)
            return false
        }
        pre_doc.ref_no = scheduler.getEvent(id).section_id
        pre_doc.car_registration_no = scheduler.getEvent(id).car_registration_no
        pre_doc.start_date = new_start
        pre_doc.end_date = new_end
        pre_doc.work_no = scheduler.getEvent(id).work_no
        pre_doc.remark = scheduler.getEvent(id).remark
        pre_doc.background = scheduler.getEvent(id).color
        pre_doc.bg_select = scheduler.getEvent(id).color
        pre_doc.return_date = scheduler.getEvent(id).return_date
        pre_doc.return_time = scheduler.getEvent(id).return_time
        pre_doc.id = id
        pre_doc.seq = scheduler.getEvent(id).seq
        pre_doc.o_start_date = o_start
        pre_doc.o_end_date = o_end
        msgConfirmEdit = (<div>
          {o_ref_no!==pre_doc.ref_no
          ?<p>ต้องการย้ายวันสำรองรถจาก Ref no. {o_ref_no} ไป Ref no. {pre_doc.ref_no} ระหว่างวันที่</p>
          :<p>ต้องการย้ายวันสำรองรถ ระหว่างวันที่</p>}
          <p>{o_start} ถึง {o_end}</p>
          <p>ไปเป็นวันที่ </p>
          <p>{new_start} ถึง {new_end}</p>
        </div>)
        that.setState({pre_doc:pre_doc,msgConfirmEdit:msgConfirmEdit},()=>{
          that.setState({showConfirm:true})
        })
      } else {
        doc = that.getEmptyDoc()
        doc.ref_no = scheduler.getEvent(id).section_id
        doc.start_date = convertDate(scheduler.getEvent(id).start_date)
        that.setState({db_new_click:true,showEdit:true,id:null,ref_no:doc.ref_no,doc:doc,validDoc:that.getEmptyValidDoc()})
      } 
    });

    scheduler.attachEvent("onDblClick", function(id,e) {
      doc.ref_no = scheduler.getEvent(id).section_id
      doc.car_registration_no = scheduler.getEvent(id).car_registration_no
      doc.start_date = scheduler.getEvent(id).start_date_text
      doc.end_date = scheduler.getEvent(id).end_date_text
      doc.work_no = scheduler.getEvent(id).work_no
      doc.remark = scheduler.getEvent(id).remark
      doc.background = scheduler.getEvent(id).color
      bg_select = scheduler.getEvent(id).color
      doc.return_date = scheduler.getEvent(id).return_date
      doc.return_time = scheduler.getEvent(id).return_time
      doc.return_status = scheduler.getEvent(id).return_status
      if (doc.return_status==='1')
        is_return = true
      else
        is_return = false  
      that.setState({is_return:is_return,bg_select:bg_select,showEdit:true,id:id,doc:doc,ref_no:doc.ref_no,seq:scheduler.getEvent(id).seq})  
    });

    scheduler.attachEvent("onBeforeLightbox", function (id){
      //any custom logic here
      return false;
    });

    scheduler.attachEvent("onBeforeTodayDisplayed", function (){
      that.setState({load_first:true,myear:Moment().format('YYYY'),mmonth:Moment().format('MM')},()=>{
        that.loadData((data)=>{
          that.initTimeline(data)
        })
      })  
      return true;
    });

    scheduler.attachEvent("onViewChange", function (new_mode , new_date){
      var year = new_date.getFullYear();
      var month = (new_date.getMonth() + 1);
      if ((year!==myear*1)||(month!==mmonth*1)) {
        let sm = month
        if (sm<10)
          sm = '0'+sm
        else
          sm = sm.toString()  
        
        that.setState({myear:year.toString(),mmonth:sm},()=>{
          if (!that.state.lock_load&&wait_load===0) {
            wait_load++
            that.setState({lock_load:true,wait_load:true,loading:true},()=>{
              that.loadData((rdata)=>{
                that.initTimeline(rdata,0,()=>{
                  that.setState({lock_load:false,load_first:false,loading:false},()=>{
                    wait_load = 0
                  })
                })
              })
            })
          }  
        })
      } else {
        if (!that.state.load_first&&!that.state.lock_load) {
          that.setState({lock_load:true,myear:Moment().format('YYYY'),mmonth:Moment().format('MM')},()=>{
            that.loadData((rdata)=>{
              that.initTimeline(rdata,1)
              wait_load = 0
            })
          })
        }
      }
    });

    scheduler.attachEvent("onTemplatesReady", function() {
      scheduler.xy.scale_height = 50;
    });

    scheduler.addMarkedTimespan({
      days: 0,
      zones: "fullday",
      css: "red_section"
    });

    scheduler.attachEvent("onBeforeViewChange", function(old_mode,old_date,mode,date){
      var year = date.getFullYear();
      var month = (date.getMonth() + 1);
      var d = new Date(year, month, 0);
      scheduler.matrix[view_name].x_size = d.getDate();
      return true;
    });  
  }

  createTimelineView(sections) {
    var view_name = "timeline";
    const scheduler = window.scheduler;
    scheduler.createTimelineView({
      name: view_name,
      x_unit: "day",
      x_date: "%D<br><b>%j</b>",
      x_step: 1,
      x_size: 31,
      section_autoheight: false,
      y_unit: sections,
      y_property: "section_id",
      render:"bar",
      round_position:true,
      dy:60
    });    
    
    scheduler.date['add_' + view_name] = function(date, step){
      if(step > 0){
        step = 1;
      }else if(step < 0){
        step = -1;
      }
      return scheduler.date.add(date, step, "month")
    };
    scheduler.date[view_name + '_start'] = scheduler.date.month_start;

    // end timeline config

    //===============
    //Data loading
    //===============
    scheduler.config.lightbox.sections = [
      {name:"description", height:130, map_to:"text", type:"textarea", focus:true},
      {name:"custom", height:23, type:"select", options:sections, map_to:"section_id"},
      {name:"time", height:72, type:"time", map_to:"auto"}
    ];
 
  }

  initTimeline(data,lock_load=0,completeFunc=undefined) {
    const {mmonth,myear} = this.state
    const scheduler = window.scheduler;
    
    scheduler.clearAll();
  
    setTimeout(()=>{  
      let year = myear*1
      let month = (mmonth*1)-1
      let day = Moment().format('DD')*1
      let timeline_data = []
      let sections = data.reduce((rresult,item,index)=>{
        timeline_data.push({
          start_date:item.start_date.split("/").reverse().join("-")+' 00:00:00', 
          end_date:item.end_date.split("/").reverse().join("-")+' 23:59:59',
          start_date_text:item.start_date, 
          end_date_text:item.end_date, 
          text:item.title, 
          car_registration_no:item.car_registration_no, 
          section_id:item.ref_no,
          color:item.background,
          seq:index,
          work_no:item.work_no,
          return_date:item.return_date,
          return_time:item.return_time,
          return_status:item.return_status,
          remark:item.remark
        })
        if (rresult.findIndex(x=>x.key===item.ref_no)===-1)
          rresult.push({key:item.ref_no,label:item.ref_no})
        return rresult 
      },[])
      this.createTimelineView(sections)
      scheduler.config.container_autoresize = false;
      scheduler.init('scheduler_here',new Date(year,month,day),"timeline");
      scheduler.parse(timeline_data)
      this.renderColBtn(this)
      if (lock_load)
        this.setState({lock_load:false,load_first:false}) 
       
      setTimeout(()=>{
        if (completeFunc!==undefined)
          completeFunc()
      },1000)
    },100)
  }

  onPlanAdd(rowId) {
    let {doc} = this.state
    doc = this.getEmptyDoc()
    doc.ref_no = rowId
    this.setState({showEdit:true,id:null,ref_no:rowId,doc:doc,validDoc:this.getEmptyValidDoc()})
  }

  renderColBtn(that) {
    const dhx_rows = document.querySelectorAll(".dhx_timeline_label_row");
    for (const dhx_row of dhx_rows) {
      var rowId = dhx_row.getAttribute("data-row-id");
      var element = '<div class="dhx-row-add-btn" style="position:absolute;right:5px;top:0;"></div>';
      var ele = document.createElement("div");
      ele.innerHTML = element;
      var colElement = ele.firstChild
      dhx_row.appendChild(colElement);

      var creBtn = document.createElement('BUTTON');
      creBtn.type = 'button';
      creBtn.innerHTML = '<i class="fa fa-plus"></i>';
      creBtn.className = 'btn btn-xs btn-success';
      creBtn.onclick = that.onPlanAdd.bind(this,rowId);
      dhx_row.querySelector(".dhx-row-add-btn").appendChild(creBtn);
    }

    const dhx_bars = document.querySelectorAll(".dhx_scale_bar");
    for (const dhx_bar of dhx_bars) {
      var label = dhx_bar.getAttribute("aria-label");
      if (label.indexOf('อา')!==-1) {
        dhx_bar.classList.add("sunday-mark");
      }
    }  
    // window.scheduler.addMarkedTimespan({
    //   days: 0,
    //   zones: "fullday",
    //   css: "red_section"
    // });     
  }

  renderEditModal() {
    let {showEdit,is_return,doc,validDoc,bg_select,seq} = this.state
    return(
      <BackupCarReservedModal
        ref='backupCarReservedModal'
        show={showEdit}
        is_return={is_return}
        doc={doc}
        validDoc={validDoc}
        bg_select={bg_select}
        seq={seq}
        onBeforeEditSave={this.onBeforeEditSave.bind(this)}
        onEditHide={this.onEditHide.bind(this)}
        onJustEditHide={this.onJustEditHide.bind(this)}
        onConfirmDel={this.onConfirmDel.bind(this)}
      />
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <Box loading={loading}>
          <Box.Body>
            <div id="scheduler_here" className="dhx_cal_container" style={{width:'100%',height:(window.innerHeight)+'px'}}>
              
            </div>
          </Box.Body>  
        </Box>
        {this.renderEditModal()}
        <ConfirmPopup 
          show={this.state.showConfirm}
          title={'ยืนยันการย้ายวันสำรองรถ'}
          message={this.state.msgConfirmEdit}
          onConfirm={this.onConfirmEditSave.bind(this)}
          onHide={this.onConfirmEditHide.bind(this,0)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )
  }
}

export default CarPlan;


// WEBPACK FOOTER //
// ./src/view/backupcar/CarPlan.js